(function () {
  const playVideo = (video) => {

  }

  const stopVideo = (video) => {

  }

  const initSection = (section) => {
    let sectionVideo = document.currentScript ? document.currentScript.parentElement: section;

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {

        }
      })
    })
  }

  // Apply background color with opacity to overlays
  const applyOverlayBackgroundColor = () => {
    const overlays = document.querySelectorAll('.video-section__custom-overlay[data-bg-color]');

    overlays.forEach(overlay => {
      const bgColor = overlay.dataset.bgColor;
      const bgOpacity = parseFloat(overlay.dataset.bgOpacity || 1);

      if (bgColor) {
        // Convert hex to rgba
        const hex = bgColor.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        overlay.style.backgroundColor = `rgba(${r}, ${g}, ${b}, ${bgOpacity})`;
      }
    });
  };

  // Prevent video download
  const preventVideoDownload = () => {
    const videoSections = document.querySelectorAll('.video-section');

    videoSections.forEach(section => {
      // Prevent right-click on video elements
      section.addEventListener('contextmenu', (e) => {
        const target = e.target;
        if (target.tagName === 'VIDEO' || target.tagName === 'IFRAME') {
          e.preventDefault();
          return false;
        }
      });

      // Add attributes to native video elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.tagName === 'VIDEO') {
              node.setAttribute('controlsList', 'nodownload nofullscreen');
              node.setAttribute('disablePictureInPicture', 'true');
              node.oncontextmenu = () => false;
            }
          });
        });
      });

      observer.observe(section, { childList: true, subtree: true });

      // Also apply to existing videos
      const existingVideos = section.querySelectorAll('video');
      existingVideos.forEach(video => {
        video.setAttribute('controlsList', 'nodownload nofullscreen');
        video.setAttribute('disablePictureInPicture', 'true');
        video.oncontextmenu = () => false;
      });
    });
  };

  // Handle custom overlay click
  const handleCustomOverlay = () => {
    const clickableOverlays = document.querySelectorAll('.video-section__custom-overlay-clickable');

    clickableOverlays.forEach(clickableOverlay => {
      clickableOverlay.addEventListener('click', function() {
        const sectionId = this.dataset.videoSection;
        const mediaId = this.dataset.mediaId;
        const videoSection = document.getElementById(sectionId);

        if (!videoSection) {
          console.error('Video section not found:', sectionId);
          return;
        }

        // Find the deferred-media element
        let deferredMedia = videoSection.querySelector('deferred-media');

        if (!deferredMedia) {
          console.error('Deferred media not found in section');
          return;
        }

        // Function to unmute and play the video
        const unmuteAndPlay = () => {
          // Find the video element (can be iframe or video tag)
          const iframe = deferredMedia.querySelector('iframe');
          const videoElement = deferredMedia.querySelector('video');

          console.log('Found iframe:', iframe, 'Found video:', videoElement);

          if (iframe) {
            // Handle YouTube or Vimeo iframe
            if (iframe.src.includes('youtube.com')) {
              console.log('Unmuting YouTube video');
              iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', '*');
              iframe.contentWindow.postMessage('{"event":"command","func":"seekTo","args":[0, true]}', '*');
              iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            } else if (iframe.src.includes('vimeo.com')) {
              console.log('Unmuting Vimeo video');
              iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', '*');
              iframe.contentWindow.postMessage('{"method":"setCurrentTime","value":0}', '*');
              iframe.contentWindow.postMessage('{"method":"play"}', '*');
            }
          } else if (videoElement) {
            // Handle native video element
            console.log('Unmuting native video');
            videoElement.muted = false;
            videoElement.currentTime = 0;
            videoElement.play().catch(err => console.error('Play error:', err));
          } else {
            console.warn('No video element found yet');
          }
        };

        // Check if video is already loaded
        const iframe = deferredMedia.querySelector('iframe');
        const videoElement = deferredMedia.querySelector('video');

        if (iframe || videoElement) {
          // Video already loaded, just unmute and play
          console.log('Video already loaded');
          unmuteAndPlay();
        } else {
          // Video not loaded yet, click the poster to load it
          const poster = deferredMedia.querySelector('.deferred-media__poster');
          if (poster) {
            console.log('Clicking poster to load video');
            poster.click();

            // Wait for video to load and then unmute
            setTimeout(() => {
              unmuteAndPlay();
            }, 1000);
          } else {
            console.warn('No poster found');
          }
        }

        // Hide both the clickable overlay and visual overlay
        this.style.display = 'none';
        const visualOverlay = videoSection.querySelector('.video-section__custom-overlay');
        if (visualOverlay) {
          visualOverlay.style.display = 'none';
        }
      });
    });
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      applyOverlayBackgroundColor();
      handleCustomOverlay();
      preventVideoDownload();
    });
  } else {
    applyOverlayBackgroundColor();
    handleCustomOverlay();
    preventVideoDownload();
  }

  document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
    applyOverlayBackgroundColor();
    handleCustomOverlay();
    preventVideoDownload();
	});
})()